// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/financial/budget.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_proto_model_core_common } from "../core/common_pb";
import { file_proto_model_core_money } from "../core/money_pb";

/**
 * Describes the file proto/model/financial/budget.proto.
 */
export const file_proto_model_financial_budget = /*@__PURE__*/
  fileDesc("CiJwcm90by9tb2RlbC9maW5hbmNpYWwvYnVkZ2V0LnByb3RvEgZjYXJtZW4ipgEKDkNhdGVnb3J5QnVkZ2V0EikKCGNhdGVnb3J5GAEgASgOMhcuY2FybWVuLkV4cGVuc2VDYXRlZ29yeRImCgppbXBvcnRhbmNlGAIgASgOMhIuY2FybWVuLkltcG9ydGFuY2USJAoNdGFyZ2V0X2J1ZGdldBgDIAEoCzINLmNhcm1lbi5Nb25leRIbChNjYXRlZ29yeV9tdWx0aXBsaWVyGAQgASgCIqIBCg1Mb2RnaW5nQnVkZ2V0EicKEHBlcl9uaWdodF90YXJnZXQYASABKAsyDS5jYXJtZW4uTW9uZXkSKAoRcGVyX25pZ2h0X21heGltdW0YAiABKAsyDS5jYXJtZW4uTW9uZXkSJAoNdG90YWxfbWF4aW11bRgDIAEoCzINLmNhcm1lbi5Nb25leRIYChBlc3RpbWF0ZWRfbmlnaHRzGAQgASgFIm8KDEV4cGVuc2VTcGxpdBIYChB0cmF2ZWxlcl91c2VyX2lkGAEgASgJEhgKEHNoYXJlX3BlcmNlbnRhZ2UYAiABKAISKwoUbWF4aW11bV9jb250cmlidXRpb24YAyABKAsyDS5jYXJtZW4uTW9uZXkiugEKDkJ1ZGdldFRlbXBsYXRlEhMKC3RlbXBsYXRlX2lkGAEgASgJEgwKBG5hbWUYAiABKAkSEwoLZGVzY3JpcHRpb24YAyABKAkSNAoUY2F0ZWdvcnlfcHJlZmVyZW5jZXMYBCADKAsyFi5jYXJtZW4uQ2F0ZWdvcnlCdWRnZXQSOgobZGVmYXVsdF9sb2RnaW5nX3ByZWZlcmVuY2VzGAUgASgLMhUuY2FybWVuLkxvZGdpbmdCdWRnZXQiXgodRGVzdGluYXRpb25DYXRlZ29yeU11bHRpcGxpZXISKQoIY2F0ZWdvcnkYASABKA4yFy5jYXJtZW4uRXhwZW5zZUNhdGVnb3J5EhIKCm11bHRpcGxpZXIYAiABKAIirwEKFkRlc3RpbmF0aW9uTXVsdGlwbGllcnMSFgoOZGVzdGluYXRpb25faWQYASABKAkSIQoZY29zdF9vZl9saXZpbmdfbXVsdGlwbGllchgCIAEoAhJDChRjYXRlZ29yeV9tdWx0aXBsaWVycxgDIAMoCzIlLmNhcm1lbi5EZXN0aW5hdGlvbkNhdGVnb3J5TXVsdGlwbGllchIVCg1jdXJyZW5jeV9jb2RlGAQgASgJIvsECgZCdWRnZXQSEQoJYnVkZ2V0X2lkGAEgASgJEg8KB3RyaXBfaWQYAiABKAkSIwoMdG90YWxfYnVkZ2V0GAMgASgLMg0uY2FybWVuLk1vbmV5EiUKDm1pbmltdW1fYnVmZmVyGAQgASgLMg0uY2FybWVuLk1vbmV5EjAKEGNhdGVnb3J5X2J1ZGdldHMYBSADKAsyFi5jYXJtZW4uQ2F0ZWdvcnlCdWRnZXQSNQoWb3ZlcmFsbF9sb2RnaW5nX2J1ZGdldBgGIAEoCzIVLmNhcm1lbi5Mb2RnaW5nQnVkZ2V0ElwKIWRlc3RpbmF0aW9uX2lkX3RvX2xvZGdpbmdfYnVkZ2V0cxgHIAMoCzIxLmNhcm1lbi5CdWRnZXQuRGVzdGluYXRpb25JZFRvTG9kZ2luZ0J1ZGdldHNFbnRyeRIsCg5leHBlbnNlX3NwbGl0cxgIIAMoCzIULmNhcm1lbi5FeHBlbnNlU3BsaXQSEwoLdGVtcGxhdGVfaWQYCSABKAkSPwoXZGVzdGluYXRpb25fbXVsdGlwbGllcnMYCiABKAsyHi5jYXJtZW4uRGVzdGluYXRpb25NdWx0aXBsaWVycxIrCgdjcmVhdGVkGAsgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIsCghtb2RpZmllZBgMIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAaWwoiRGVzdGluYXRpb25JZFRvTG9kZ2luZ0J1ZGdldHNFbnRyeRILCgNrZXkYASABKAkSJAoFdmFsdWUYAiABKAsyFS5jYXJtZW4uTG9kZ2luZ0J1ZGdldDoCOAEiuQEKFENhdGVnb3J5QnVkZ2V0SW1wYWN0EikKCGNhdGVnb3J5GAEgASgOMhcuY2FybWVuLkV4cGVuc2VDYXRlZ29yeRIlCg5lc3RpbWF0ZWRfY29zdBgCIAEoCzINLmNhcm1lbi5Nb25leRInChBidWRnZXRfcmVtYWluaW5nGAMgASgLMg0uY2FybWVuLk1vbmV5EiYKD2J1ZGdldF9leGNlZWRlZBgEIAEoCzINLmNhcm1lbi5Nb25leSJ/Cg1DYW5kaWRhdGVDb3N0EhQKDGNhbmRpZGF0ZV9pZBgBIAEoCRIlCg5lc3RpbWF0ZWRfY29zdBgCIAEoCzINLmNhcm1lbi5Nb25leRIxChBwcmltYXJ5X2NhdGVnb3J5GAMgASgOMhcuY2FybWVuLkV4cGVuc2VDYXRlZ29yeSLDAQoWQnVkZ2V0VmFsaWRhdGlvblJlc3VsdBIpCghjYXRlZ29yeRgBIAEoDjIXLmNhcm1lbi5FeHBlbnNlQ2F0ZWdvcnkSFQoNd2l0aGluX2J1ZGdldBgCIAEoCBIjCgxidWRnZXRfbGltaXQYAyABKAsyDS5jYXJtZW4uTW9uZXkSJgoPZXN0aW1hdGVkX3NwZW5kGAQgASgLMg0uY2FybWVuLk1vbmV5EhoKEnZhbGlkYXRpb25fbWVzc2FnZRgFIAEoCSKMAgoMQnVkZ2V0U3RhdHVzEhEKCWJ1ZGdldF9pZBgBIAEoCRIjCgx0b3RhbF9idWRnZXQYAiABKAsyDS5jYXJtZW4uTW9uZXkSIgoLdG90YWxfc3BlbnQYAyABKAsyDS5jYXJtZW4uTW9uZXkSJgoPdG90YWxfY29tbWl0dGVkGAQgASgLMg0uY2FybWVuLk1vbmV5EiYKD3RvdGFsX2F2YWlsYWJsZRgFIAEoCzINLmNhcm1lbi5Nb25leRIeChZ1dGlsaXphdGlvbl9wZXJjZW50YWdlGAYgASgCEjAKDGxhc3RfdXBkYXRlZBgHIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAi+gEKFENhdGVnb3J5QnVkZ2V0U3RhdHVzEikKCGNhdGVnb3J5GAEgASgOMhcuY2FybWVuLkV4cGVuc2VDYXRlZ29yeRIgCglhbGxvY2F0ZWQYAiABKAsyDS5jYXJtZW4uTW9uZXkSHAoFc3BlbnQYAyABKAsyDS5jYXJtZW4uTW9uZXkSIAoJY29tbWl0dGVkGAQgASgLMg0uY2FybWVuLk1vbmV5EiAKCWF2YWlsYWJsZRgFIAEoCzINLmNhcm1lbi5Nb25leRIeChZ1dGlsaXphdGlvbl9wZXJjZW50YWdlGAYgASgCEhMKC292ZXJfYnVkZ2V0GAcgASgIIpwCCg5CdWRnZXRGb3JlY2FzdBInChB0b3RhbF9mb3JlY2FzdGVkGAEgASgLMg0uY2FybWVuLk1vbmV5EisKFGNvbmZpZGVuY2VfcmFuZ2VfbG93GAIgASgLMg0uY2FybWVuLk1vbmV5EiwKFWNvbmZpZGVuY2VfcmFuZ2VfaGlnaBgDIAEoCzINLmNhcm1lbi5Nb25leRIdChVjb25maWRlbmNlX3BlcmNlbnRhZ2UYBCABKAISMQoNZm9yZWNhc3RfZGF0ZRgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASNAoQZm9yZWNhc3RfaG9yaXpvbhgGIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAimAEKEENhdGVnb3J5Rm9yZWNhc3QSKQoIY2F0ZWdvcnkYASABKA4yFy5jYXJtZW4uRXhwZW5zZUNhdGVnb3J5EigKEWZvcmVjYXN0ZWRfYW1vdW50GAIgASgLMg0uY2FybWVuLk1vbmV5EhUKDWJvb2tpbmdfY291bnQYAyABKAUSGAoQY29uZmlkZW5jZV9sZXZlbBgEIAEoAiLdAQoQQnVkZ2V0VmFsaWRhdGlvbhIQCghhcHByb3ZlZBgBIAEoCBIaChJ2YWxpZGF0aW9uX21lc3NhZ2UYAiABKAkSJwoQYXZhaWxhYmxlX2Ftb3VudBgDIAEoCzINLmNhcm1lbi5Nb25leRInChByZXF1ZXN0ZWRfYW1vdW50GAQgASgLMg0uY2FybWVuLk1vbmV5EiUKDm92ZXJhZ2VfYW1vdW50GAUgASgLMg0uY2FybWVuLk1vbmV5EiIKCHNldmVyaXR5GAYgASgOMhAuY2FybWVuLlNldmVyaXR5IsgBCgxCdWRnZXRJbXBhY3QSKQoIY2F0ZWdvcnkYASABKA4yFy5jYXJtZW4uRXhwZW5zZUNhdGVnb3J5EiQKDWltcGFjdF9hbW91bnQYAiABKAsyDS5jYXJtZW4uTW9uZXkSLQoWcmVtYWluaW5nX2FmdGVyX2ltcGFjdBgDIAEoCzINLmNhcm1lbi5Nb25leRIWCg5leGNlZWRzX2J1ZGdldBgEIAEoCBIgChh1dGlsaXphdGlvbl9hZnRlcl9pbXBhY3QYBSABKAIi2gIKC0J1ZGdldEFsZXJ0EhAKCGFsZXJ0X2lkGAEgASgJEisKCmFsZXJ0X3R5cGUYAiABKA4yFy5jYXJtZW4uQnVkZ2V0QWxlcnRUeXBlEikKCGNhdGVnb3J5GAMgASgOMhcuY2FybWVuLkV4cGVuc2VDYXRlZ29yeRInChB0aHJlc2hvbGRfYW1vdW50GAQgASgLMg0uY2FybWVuLk1vbmV5EiUKDmN1cnJlbnRfYW1vdW50GAUgASgLMg0uY2FybWVuLk1vbmV5EhwKFHBlcmNlbnRhZ2VfdGhyZXNob2xkGAYgASgCEhoKEmN1cnJlbnRfcGVyY2VudGFnZRgHIAEoAhIPCgdtZXNzYWdlGAggASgJEjAKDHRyaWdnZXJlZF9hdBgJIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASFAoMYWNrbm93bGVkZ2VkGAogASgIItcCChFCdWRnZXRUcmFuc2FjdGlvbhIWCg50cmFuc2FjdGlvbl9pZBgBIAEoCRIRCglidWRnZXRfaWQYAiABKAkSKwoEdHlwZRgDIAEoDjIdLmNhcm1lbi5CdWRnZXRUcmFuc2FjdGlvblR5cGUSHQoGYW1vdW50GAQgASgLMg0uY2FybWVuLk1vbmV5EikKCGNhdGVnb3J5GAUgASgOMhcuY2FybWVuLkV4cGVuc2VDYXRlZ29yeRITCgtkZXNjcmlwdGlvbhgGIAEoCRIUCgxyZWZlcmVuY2VfaWQYByABKAkSNAoQdHJhbnNhY3Rpb25fZGF0ZRgIIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASKwoHY3JlYXRlZBgJIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASEgoKY3JlYXRlZF9ieRgKIAEoCSLAAQoXQnVkZ2V0UmViYWxhbmNlU3RyYXRlZ3kSKQoEdHlwZRgBIAEoDjIbLmNhcm1lbi5CdWRnZXRSZWJhbGFuY2VUeXBlEjQKE3ByaW9yaXR5X2NhdGVnb3JpZXMYAiADKA4yFy5jYXJtZW4uRXhwZW5zZUNhdGVnb3J5EiEKGXByZXNlcnZlX2VtZXJnZW5jeV9idWZmZXIYAyABKAgSIQoZbWF4aW11bV9jaGFuZ2VfcGVyY2VudGFnZRgEIAEoAiLTAQoWQnVkZ2V0QWxsb2NhdGlvbkNoYW5nZRIpCghjYXRlZ29yeRgBIAEoDjIXLmNhcm1lbi5FeHBlbnNlQ2F0ZWdvcnkSKgoTcHJldmlvdXNfYWxsb2NhdGlvbhgCIAEoCzINLmNhcm1lbi5Nb25leRIlCg5uZXdfYWxsb2NhdGlvbhgDIAEoCzINLmNhcm1lbi5Nb25leRIkCg1jaGFuZ2VfYW1vdW50GAQgASgLMg0uY2FybWVuLk1vbmV5EhUKDWNoYW5nZV9yZWFzb24YBSABKAkipAEKEVBvdGVudGlhbFB1cmNoYXNlEh0KBmFtb3VudBgBIAEoCzINLmNhcm1lbi5Nb25leRIpCghjYXRlZ29yeRgCIAEoDjIXLmNhcm1lbi5FeHBlbnNlQ2F0ZWdvcnkSEwoLZGVzY3JpcHRpb24YAyABKAkSMAoMcGxhbm5lZF9kYXRlGAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCr1AQoPRXhwZW5zZUNhdGVnb3J5EiAKHEVYUEVOU0VfQ0FURUdPUllfVU5TUEVDSUZJRUQQABIcChhFWFBFTlNFX0NBVEVHT1JZX0xPREdJTkcQARIZChVFWFBFTlNFX0NBVEVHT1JZX0ZPT0QQAhIjCh9FWFBFTlNFX0NBVEVHT1JZX1RSQU5TUE9SVEFUSU9OEAMSHwobRVhQRU5TRV9DQVRFR09SWV9BQ1RJVklUSUVTEAQSHQoZRVhQRU5TRV9DQVRFR09SWV9TSE9QUElORxAFEiIKHkVYUEVOU0VfQ0FURUdPUllfTUlTQ0VMTEFORU9VUxAGKoECCg9CdWRnZXRBbGVydFR5cGUSIQodQlVER0VUX0FMRVJUX1RZUEVfVU5TUEVDSUZJRUQQABInCiNCVURHRVRfQUxFUlRfVFlQRV9USFJFU0hPTERfV0FSTklORxABEigKJEJVREdFVF9BTEVSVF9UWVBFX1RIUkVTSE9MRF9FWENFRURFRBACEiYKIkJVREdFVF9BTEVSVF9UWVBFX0JVREdFVF9FWEhBVVNURUQQAxImCiJCVURHRVRfQUxFUlRfVFlQRV9GT1JFQ0FTVF9XQVJOSU5HEAQSKAokQlVER0VUX0FMRVJUX1RZUEVfQ0FURUdPUllfT1ZFUlNQRU5EEAUq0wIKFUJ1ZGdldFRyYW5zYWN0aW9uVHlwZRInCiNCVURHRVRfVFJBTlNBQ1RJT05fVFlQRV9VTlNQRUNJRklFRBAAEi4KKkJVREdFVF9UUkFOU0FDVElPTl9UWVBFX0lOSVRJQUxfQUxMT0NBVElPThABEigKJEJVREdFVF9UUkFOU0FDVElPTl9UWVBFX0FDVFVBTF9TUEVORBACEi4KKkJVREdFVF9UUkFOU0FDVElPTl9UWVBFX0JPT0tJTkdfQ09NTUlUTUVOVBADEjAKLEJVREdFVF9UUkFOU0FDVElPTl9UWVBFX0JPT0tJTkdfQ0FOQ0VMTEFUSU9OEAQSMQotQlVER0VUX1RSQU5TQUNUSU9OX1RZUEVfQUxMT0NBVElPTl9BREpVU1RNRU5UEAUSIgoeQlVER0VUX1RSQU5TQUNUSU9OX1RZUEVfUkVGVU5EEAYq3gEKE0J1ZGdldFJlYmFsYW5jZVR5cGUSJQohQlVER0VUX1JFQkFMQU5DRV9UWVBFX1VOU1BFQ0lGSUVEEAASJgoiQlVER0VUX1JFQkFMQU5DRV9UWVBFX1BST1BPUlRJT05BTBABEigKJEJVREdFVF9SRUJBTEFOQ0VfVFlQRV9QUklPUklUWV9CQVNFRBACEiwKKEJVREdFVF9SRUJBTEFOQ0VfVFlQRV9FUVVBTF9ESVNUUklCVVRJT04QAxIgChxCVURHRVRfUkVCQUxBTkNFX1RZUEVfTUFOVUFMEARCKFomZ2l0aHViLmNvbS95dW5hY2FiYS9jYXJtZW4vcHJvdG8vbW9kZWxiBnByb3RvMw", [file_google_protobuf_timestamp, file_proto_model_core_common, file_proto_model_core_money]);

/**
 * Describes the message carmen.CategoryBudget.
 * Use `create(CategoryBudgetSchema)` to create a new message.
 */
export const CategoryBudgetSchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_budget, 0);

/**
 * Describes the message carmen.LodgingBudget.
 * Use `create(LodgingBudgetSchema)` to create a new message.
 */
export const LodgingBudgetSchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_budget, 1);

/**
 * Describes the message carmen.ExpenseSplit.
 * Use `create(ExpenseSplitSchema)` to create a new message.
 */
export const ExpenseSplitSchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_budget, 2);

/**
 * Describes the message carmen.BudgetTemplate.
 * Use `create(BudgetTemplateSchema)` to create a new message.
 */
export const BudgetTemplateSchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_budget, 3);

/**
 * Describes the message carmen.DestinationCategoryMultiplier.
 * Use `create(DestinationCategoryMultiplierSchema)` to create a new message.
 */
export const DestinationCategoryMultiplierSchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_budget, 4);

/**
 * Describes the message carmen.DestinationMultipliers.
 * Use `create(DestinationMultipliersSchema)` to create a new message.
 */
export const DestinationMultipliersSchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_budget, 5);

/**
 * Describes the message carmen.Budget.
 * Use `create(BudgetSchema)` to create a new message.
 */
export const BudgetSchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_budget, 6);

/**
 * Describes the message carmen.CategoryBudgetImpact.
 * Use `create(CategoryBudgetImpactSchema)` to create a new message.
 */
export const CategoryBudgetImpactSchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_budget, 7);

/**
 * Describes the message carmen.CandidateCost.
 * Use `create(CandidateCostSchema)` to create a new message.
 */
export const CandidateCostSchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_budget, 8);

/**
 * Describes the message carmen.BudgetValidationResult.
 * Use `create(BudgetValidationResultSchema)` to create a new message.
 */
export const BudgetValidationResultSchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_budget, 9);

/**
 * Describes the message carmen.BudgetStatus.
 * Use `create(BudgetStatusSchema)` to create a new message.
 */
export const BudgetStatusSchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_budget, 10);

/**
 * Describes the message carmen.CategoryBudgetStatus.
 * Use `create(CategoryBudgetStatusSchema)` to create a new message.
 */
export const CategoryBudgetStatusSchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_budget, 11);

/**
 * Describes the message carmen.BudgetForecast.
 * Use `create(BudgetForecastSchema)` to create a new message.
 */
export const BudgetForecastSchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_budget, 12);

/**
 * Describes the message carmen.CategoryForecast.
 * Use `create(CategoryForecastSchema)` to create a new message.
 */
export const CategoryForecastSchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_budget, 13);

/**
 * Describes the message carmen.BudgetValidation.
 * Use `create(BudgetValidationSchema)` to create a new message.
 */
export const BudgetValidationSchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_budget, 14);

/**
 * Describes the message carmen.BudgetImpact.
 * Use `create(BudgetImpactSchema)` to create a new message.
 */
export const BudgetImpactSchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_budget, 15);

/**
 * Describes the message carmen.BudgetAlert.
 * Use `create(BudgetAlertSchema)` to create a new message.
 */
export const BudgetAlertSchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_budget, 16);

/**
 * Describes the message carmen.BudgetTransaction.
 * Use `create(BudgetTransactionSchema)` to create a new message.
 */
export const BudgetTransactionSchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_budget, 17);

/**
 * Describes the message carmen.BudgetRebalanceStrategy.
 * Use `create(BudgetRebalanceStrategySchema)` to create a new message.
 */
export const BudgetRebalanceStrategySchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_budget, 18);

/**
 * Describes the message carmen.BudgetAllocationChange.
 * Use `create(BudgetAllocationChangeSchema)` to create a new message.
 */
export const BudgetAllocationChangeSchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_budget, 19);

/**
 * Describes the message carmen.PotentialPurchase.
 * Use `create(PotentialPurchaseSchema)` to create a new message.
 */
export const PotentialPurchaseSchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_budget, 20);

/**
 * Describes the enum carmen.ExpenseCategory.
 */
export const ExpenseCategorySchema = /*@__PURE__*/
  enumDesc(file_proto_model_financial_budget, 0);

/**
 * Represents a category of travel expenses for budget allocation and tracking
 * This is distinct from FoodCategory (food.proto) which is for dietary preferences.
 * ExpenseCategory groups spending for budget planning, not content classification.
 *
 * @generated from enum carmen.ExpenseCategory
 */
export const ExpenseCategory = /*@__PURE__*/
  tsEnum(ExpenseCategorySchema);

/**
 * Describes the enum carmen.BudgetAlertType.
 */
export const BudgetAlertTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_financial_budget, 1);

/**
 * @generated from enum carmen.BudgetAlertType
 */
export const BudgetAlertType = /*@__PURE__*/
  tsEnum(BudgetAlertTypeSchema);

/**
 * Describes the enum carmen.BudgetTransactionType.
 */
export const BudgetTransactionTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_financial_budget, 2);

/**
 * @generated from enum carmen.BudgetTransactionType
 */
export const BudgetTransactionType = /*@__PURE__*/
  tsEnum(BudgetTransactionTypeSchema);

/**
 * Describes the enum carmen.BudgetRebalanceType.
 */
export const BudgetRebalanceTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_financial_budget, 3);

/**
 * @generated from enum carmen.BudgetRebalanceType
 */
export const BudgetRebalanceType = /*@__PURE__*/
  tsEnum(BudgetRebalanceTypeSchema);

